import React, { useEffect, useState } from "react";
import {
  Form,
  Row,
  Col,
  Card,
  Spin,
  Modal,
  DatePicker,
  Button,
  Input,
  Checkbox
} from "antd";

//import { Input as InputDsGov, Button, Group, Card as CardDsGov, Row, Col as ColDsgov } from "react-dsgov";

import { errorMessage, successMessage } from "../../../messages/messages";

import dayjs from "dayjs";
import { disabledDate, isStateValid, isValidNup, onlyNumbers, pushToBase } from "../../../utils/utilsFunctions";
import SelecionarPessoaJuridica from "../../../components/SelecionarPessoaJuridica";
import { apiPrimarias } from "../../../services/api";
import type { IAutorizacaoEfpc, IPessoaJuridica } from "../../../components/Interfaces";
import { CheckOutlined } from "@ant-design/icons";
import { maskNumeroProcesso } from "../../../utils/maskFunctions";
import type { CheckboxProps } from "antd/lib";
import TextArea from "antd/lib/input/TextArea";
import { PatternFormat } from "react-number-format";
import { useLocation, useNavigate } from "react-router";

const OperacaoAutorizacaoEfpc: React.FC<any> = () => {

  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { state } = useLocation();


  const [pessoaJuridicaRequerente, setPessoaJuridicaRequerente] = useState<IPessoaJuridica>();
  const [pessoaJuridicaEntidade, setPessoaJuridicaEntidade] = useState<IPessoaJuridica>();
  const [numeroProcesso, setNumeroProcesso] = useState("");
  const [razaoSocial, setRazaoSocial] = useState("");
  const [cadastrarPessoaJuridicaSomenteComNumeroProcesso, setCadastrarPessoaJuridicaSomenteComNumeroProcesso] = useState(false);


  const [loading, setLoading] = useState(false);
  const [tipLoading, _setTipLoading] = useState("");

  const [modalRequisicaoAberto, setModalRequisicaoAberto] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0)
    if (isStateValid(state)) {
      //console.log(state);
      validarPessoaJuridicaRequerente(state.data);
    } else {
      errorMessage("Não foi possível identificar as operações de autorização da Entidade.");
      pushToBase(navigate);
    }
  }, []);

  useEffect(() => {
    if (pessoaJuridicaRequerente) {
      form.setFieldsValue({
        operacaoRazaoSocial: pessoaJuridicaRequerente.razaoSocial,
        operacaoCnpjRequerente: pessoaJuridicaRequerente.numero
      });
    }
  }, [pessoaJuridicaRequerente]);


  function validarPessoaJuridicaRequerente(pjReq: any) {
    if (!pjReq || pjReq.length === 0) {
      errorMessage("Requerente não identificado");
      pushToBase(navigate);
    } else {
      setPessoaJuridicaRequerente(pjReq);
    }
  }

  useEffect(() => {
    if (pessoaJuridicaEntidade) {
      setRazaoSocial(pessoaJuridicaEntidade.razaoSocial);
    }
  }, [pessoaJuridicaEntidade]);

  function pushToPessoaJuridicaOperacoes() {
    let tpSelecao = {
      data: pessoaJuridicaRequerente,
    };

    navigate("/" + import.meta.env.VITE_APP_BASE + "/operacao-pessoa-juridica", { state: tpSelecao });
  }

  const efpcAutorizacaoRequerer = async (numeroPessoaJuridicaRequerente: string, numeroPessoaJuridicaEfpcOuProcesso: string) => {
    setLoading(true);
    const currentForm = form.getFieldsValue();

    const jsonRequisicao: IAutorizacaoEfpc =
    {
      numeroPessoaJuridicaRequerente: numeroPessoaJuridicaRequerente,
      numeroPessoaJuridicaObjeto: !cadastrarPessoaJuridicaSomenteComNumeroProcesso ? onlyNumbers(numeroPessoaJuridicaEfpcOuProcesso) : undefined,
      numeroProcessoObjeto: cadastrarPessoaJuridicaSomenteComNumeroProcesso ? onlyNumbers(numeroPessoaJuridicaEfpcOuProcesso) : undefined,
      razaoSocialObjeto: currentForm.razaoSocial,
      dataPosicao: currentForm.dataPosicao ? dayjs(currentForm.dataPosicao).format('YYYY-MM-DDTHH:mm:ss') : "",
      justificativa: currentForm.justificativa,
    }

    //console.log("json subindo");
    //console.log(jsonRequisicao);

    try {
      let query = `/efpc/autorizacao/requerer`;

      await apiPrimarias.post(query, jsonRequisicao);

      successMessage(
        `Operação de Autorização de Entidade cadastrada com Sucesso`
      );

      pushToPessoaJuridicaOperacoes();

    } catch (error: any) {
      setLoading(false);
      if (error.response) {
        errorMessage(`${error.response.data.mensagem}`);
        if (error.response.data.campos) {
          error.response.data.campos.map((c: any) => {
            errorMessage(`${c.cmensagem}`);
          });
        }
      }
      // Return comentado pq esta retornando essa mensagem de erro por default para todos os erros de cadastro
      // return errorMessage("Ocorreu um erro ao tentar realizar uma operação");
    } finally {
      setModalRequisicaoAberto(false);
      setLoading(false);
    }
  };

  const onChangeCadastroPorProcesso: CheckboxProps['onChange'] = (e) => {
    setCadastrarPessoaJuridicaSomenteComNumeroProcesso(e.target.checked);
  };

  return (
    <Spin spinning={loading} tip={tipLoading}>
      <Form layout="vertical" form={form}>

        <Modal title="Requisição de Autorização de Entidade para Pessoa Jurídica"

          open={modalRequisicaoAberto}
          onOk={() => {
            if (!cadastrarPessoaJuridicaSomenteComNumeroProcesso) {
              if (pessoaJuridicaRequerente && pessoaJuridicaRequerente.numero !== ""
                && pessoaJuridicaEntidade && pessoaJuridicaEntidade.numero !== ""
              )
                efpcAutorizacaoRequerer(pessoaJuridicaRequerente.numero, pessoaJuridicaEntidade.numero)
              else
                errorMessage("Número (CNPJ, NIF, Processo) da Pessoa Jurídica não localizada.");
            } else {
              if (!numeroProcesso) {
                errorMessage("O Número do Processo é obrigatório.");
                return
              } else if (!isValidNup(numeroProcesso)) {
                errorMessage("Número do Processo inválido.");
                return
              } else {
                if (pessoaJuridicaRequerente) {
                  efpcAutorizacaoRequerer(pessoaJuridicaRequerente.numero, numeroProcesso)
                } else {
                  errorMessage("Número (CNPJ, NIF, Processo) da Pessoa Jurídica não localizada.");
                }
              }
            }
          }

          }
          onCancel={() => setModalRequisicaoAberto(false)}
        >
          <p>Requisitante: {pessoaJuridicaRequerente?.razaoSocial} </p>
          <p>Entidade: {razaoSocial} </p>

          <Row>
            <Col xs={24} md={12} xl={8}>
              <Form.Item
                label="Data Posição"
                name="dataPosicao"
                rules={[
                  {
                    required: true,
                    message: "Data posição não preenchido",
                  },
                ]}
              >
                <DatePicker
                  format={"DD/MM/YYYY"}
                  style={{ width: "100%" }}
                  disabledDate={disabledDate}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item
                label='Justificativa'
                name='justificativa'
                rules={[
                  {
                    required: true,
                    message: "Preencha justificativa da Autorização",
                  },
                ]}
              >
                <TextArea disabled={false} maxLength={300} showCount={true}
                  autoSize={{ minRows: 3, maxRows: 5 }} />
              </Form.Item>
            </Col>
          </Row>

        </Modal>


        <Card>
          <div className="main-content pl-sm-3 mt-4">
            <h2>Informações do Requerente da Autorização da EFPC</h2>
          </div>

          <Row>
            <Col xs={24} xl={6}>
              <Form.Item
                label="CNPJ do Requerente"
                name="operacaoCnpjRequerente">
                <PatternFormat
                  disabled
                  customInput={Input}
                  format="##.###.###/####-##"
                />
              </Form.Item>
            </Col>

            <Col xs={24} xl={12}>
              <Form.Item label="Razão Social"
                name="operacaoRazaoSocial">
                <Input disabled={true} />
              </Form.Item>
            </Col>
          </Row>
        </Card>

        <Checkbox onChange={onChangeCadastroPorProcesso}>Cadastrar Pessoa Jurídica nova Somente com Número do Processo</Checkbox>;
      </Form>
      <Card hidden={cadastrarPessoaJuridicaSomenteComNumeroProcesso}>
        <div className="main-content pl-sm-3 mt-4">
          <h2>Seleção da Pessoa Jurídica da Entidade</h2>
        </div>
        <SelecionarPessoaJuridica
          textoBotao="Consultar Pessoa Jurídica Entidade"
          setPessoaJuridica={setPessoaJuridicaEntidade}
        />
      </Card>
      <Form layout="vertical" form={form}>
        <Card hidden={!cadastrarPessoaJuridicaSomenteComNumeroProcesso}>
          <div className="main-content pl-sm-3 mt-4">
            <h2>Informação do Número do Processo</h2>
          </div>
          <Row>
            <Col xs={24} xl={10}>
              <Form.Item
                label="Número do Processo"
                name='numeroProcessoInformado'
                rules={[
                  {
                    required: cadastrarPessoaJuridicaSomenteComNumeroProcesso,
                    message: "O número do processo é Obrigatório",
                  },
                ]}
              >
                <Input
                  maxLength={20}
                  onChange={(e) => {
                    setNumeroProcesso(e.target.value);
                    form.setFieldsValue({
                      numeroProcessoInformado: maskNumeroProcesso(e.target.value),
                    })
                  }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} xl={15}>
              <Form.Item
                label='Nome Empresarial'
                name='razaoSocial'
                rules={[
                  {
                    required: cadastrarPessoaJuridicaSomenteComNumeroProcesso,
                    message: "Razão Social é Obrigatório",
                  },
                ]}
              >
                <Input
                  maxLength={100}
                  onChange={(e) =>
                    setRazaoSocial(e.target.value)
                  }
                />
              </Form.Item>
            </Col>
          </Row>
        </Card>
      </Form>


      <Row>
        {
          <>
            <Button shape='round'
              disabled={!pessoaJuridicaRequerente || !razaoSocial || !cadastrarPessoaJuridicaSomenteComNumeroProcesso ? !pessoaJuridicaEntidade : !numeroProcesso}
              type='primary' icon={<CheckOutlined />} htmlType='button'
              onClick={() => {
                if (!pessoaJuridicaRequerente || pessoaJuridicaRequerente.numero === "") {
                  errorMessage("Pessoa Jurídica do requerente não identificada.");
                  return
                }

                if (!cadastrarPessoaJuridicaSomenteComNumeroProcesso &&
                  (!pessoaJuridicaEntidade || pessoaJuridicaEntidade.numero === "")) {
                  errorMessage("Pessoa Jurídica da Entidade não identificada.");
                  return
                }

                if (cadastrarPessoaJuridicaSomenteComNumeroProcesso) {
                  if (!numeroProcesso || numeroProcesso === "") {
                    errorMessage("O Número do Processo é obrigatório.");
                    return
                  }
                  if (numeroProcesso && !isValidNup(numeroProcesso)) {
                    errorMessage("Número do Processo inválido.");
                    return
                  }
                }
                setModalRequisicaoAberto(true);
              }} >
              Cadastrar Operação
            </Button>

          </>
        }
      </Row>

    </Spin >
  );
};

export default OperacaoAutorizacaoEfpc;
